<div class="d-flex flex-column">
    <div class="d-flex flex-row">
        @for (step of steps; track step; let i = $index) {
            <div class="d-flex flex-row align-items-center step" [ngClass]="getStepStyle(step)">
                <div
                    class="step-icon-wrapper"
                    [attr.data-uiid]="'new-eff-workflow-step-' + step.Id"
                >
                    @if (step.Id === effectivenessPageType.Completed) {
                        <mat-icon>lens</mat-icon>
                    } @else {
                        <eff-popover
                            [popoverContentTemplate]="popoverContent"
                            [popoverButtonTemplate]="popoverButton"
                            [panelClass]="'eff-workflow-step-popover'"
                        >
                            <ng-template #popoverContent>
                                <eff-workflow-popover [step]="step"></eff-workflow-popover>
                            </ng-template>
                            <ng-template #popoverButton>
                                <mat-icon>lens</mat-icon>
                            </ng-template>
                        </eff-popover>
                    }
                    <div class="step-title" data-uiid="new-eff-workflow-step-title">
                        {{ step.NameKey | transloco }}
                    </div>
                </div>
                <div class="step-separator"></div>
            </div>
        }
    </div>
</div>
